import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { REVIEWS_STORE_NAME } from './reviews-constants';
import { ReviewsStore } from './reviews-types';
import { uploadPhoto } from './upload-photo';
import { postReview } from './post-review';

const INITIAL_STATE: ReviewsStore = {
  reviewsPhoto: [],
  postReview: {
    isProcessing: false,
    message: null,
    status: null,
  },
} as const;

export const reviews = (parentStore: Store) => {
  const store = createSubstore(parentStore, REVIEWS_STORE_NAME);
  store.on('@init', () => INITIAL_STATE)

  uploadPhoto(store, parentStore);
  postReview(store, parentStore);
};
